import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import notifications from "../../../common/Components/Notifications/Notification";
import { createCosting, getSareeCosting } from "../../../services/karkhanaApi";
import { rupees } from "../rates/rateModel";
import { useKT } from "../i18n/kt";
import { STATUS_LABEL } from "./costingModel";
import "./karkhana-costing.scss";
import { kp } from "../karkhanaPaths";

/** On a saree's page (owner/managers): its approved costing and prices, or a button to start one. */
const SareeCostingCard = ({ pieceId }: { pieceId: string }) => {
  const { t } = useKT();
  const history = useHistory();
  const [data, setData] = useState<any>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getSareeCosting(pieceId)
      .then((res: any) => setData(res?.success ? res.data : { approved: null, open: null }))
      .catch(() => undefined);
  }, [pieceId]);

  const start = async () => {
    setBusy(true);
    try {
      const res: any = await createCosting({ pieceId });
      if (res?.success) history.push(kp.costing(res.data.costing.id));
      else notifications({ title: t("Not done"), message: t(res?.message || "Could not start the costing"), type: "danger" });
    } finally {
      setBusy(false);
    }
  };

  if (!data) return null;
  const a = data.approved;
  const o = data.open;
  return (
    <div className="kc-karkhana" style={{ marginTop: 12 }}>
      <span>
        <strong>{t("Costing")}:</strong>{" "}
        {a ? (
          <>
            {t("cost price")} {rupees(a.costPrice, 0)} · {t("sale price")} <strong>{rupees(a.salePrice, 0)}</strong> ({t("approved")} v{a.versionNo})
          </>
        ) : o ? (
          t(STATUS_LABEL[o.status] || o.status)
        ) : (
          t("not done yet")
        )}
        {a && o ? ` · ${t("v{{n}} is {{status}}", { n: o.versionNo, status: t(STATUS_LABEL[o.status] || o.status).toLowerCase() })}` : ""}
      </span>
      {o || a ? (
        <Link className="kh-btn kh-btn--sm" to={kp.costing((o || a).id)}>
          {t("Open costing")}
        </Link>
      ) : (
        <button type="button" className="kh-btn kh-btn--sm is-primary" onClick={start} disabled={busy}>
          {t("Start costing")}
        </button>
      )}
    </div>
  );
};

export default SareeCostingCard;
